import { render, staticRenderFns } from "./LenovoSignUp.vue?vue&type=template&id=48715166&scoped=true&"
import script from "./LenovoSignUp.vue?vue&type=script&lang=js&"
export * from "./LenovoSignUp.vue?vue&type=script&lang=js&"
import style0 from "./LenovoSignUp.vue?vue&type=style&index=0&id=48715166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48715166",
  null
  
)

export default component.exports